import React from "react";
import DashboardNotificationsCard from "@/components/notifications/DashboardNotificationsCard";

// System Admin dashboard notifications: same swipe card as every other dashboard, with request tags.
export default function AdminNotificationsCard({ tick }) {
  return <DashboardNotificationsCard tick={tick} testId="admin-notifications-card" />;
}
